import { useState } from "react";
import { Link } from "react-router-dom";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

type FooterNavItem = { label: string; to?: string; href?: string };

const LEARN_LINKS: FooterNavItem[] = [
  { label: "Newsletter", to: "/newsletter" },
  { label: "Resources", to: "/resources" },
  { label: "Daily AI Updates", to: "/daily-ai-updates" },
  { label: "Video Resources", to: "/all-resources" },
];

const CONNECT_LINKS: FooterNavItem[] = [
  { label: "Upskill your Team", to: "/business" },
  { label: "Invite Vaibhav as Speaker", to: "/invite-as-speaker" },
];

function IconInstagram({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
    </svg>
  );
}

function IconThreads({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 22 22" fill="none" aria-hidden>
      <path d="M16.1921 10.2486C16.1672 7.34931 14.6006 5.60223 11.9541 5.60223C10.1878 5.60223 8.70229 6.40374 7.92209 7.68119L9.63227 8.87722C10.0754 8.17589 10.6871 7.59352 11.8106 7.59352C13.0776 7.59352 13.733 8.30112 13.9202 9.61613C13.3085 9.52221 12.6969 9.47212 12.0665 9.47212C8.6461 9.47212 7.03578 11.0251 7.03578 13.079C7.03578 15.1705 8.6461 16.3978 11.0179 16.3978C13.6206 16.3978 15.1748 14.6382 15.8114 12.459C16.473 12.7596 16.9286 13.461 16.9286 14.5129C16.9286 17.3308 13.6893 18.865 10.943 18.865C6.89223 18.865 4.24581 16.1974 4.24581 11.8579C4.24581 6.54152 7.74731 3.13504 12.4534 3.13504C15.6117 3.13504 17.172 4.52519 18.2331 6.39123L19.9807 5.16389C18.8261 2.74679 16.2483 1.01849 12.3785 1.01849C6.2119 1.01849 2.01758 5.40811 2.01758 11.7765C2.01758 17.6001 6.12452 20.9815 11.0179 20.9815C15.0624 20.9815 19.1506 18.6145 19.1506 14.563C19.1506 12.4465 17.9398 11.0438 16.1921 10.2486ZM10.943 14.2875C10.0505 14.2875 9.26403 13.8617 9.26403 13.079C9.26403 11.8454 10.7745 11.4696 12.2537 11.4696C12.8155 11.4696 13.3647 11.5072 13.8516 11.6137C13.502 13.2167 12.4659 14.2875 10.943 14.2875Z" fill="currentColor" />
    </svg>
  );
}

function IconX({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231 5.45-6.231zm-1.161 17.52h1.833L7.084 4.126H5.117L17.083 19.77z" />
    </svg>
  );
}

function IconLinkedIn({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
    </svg>
  );
}

function IconYouTube({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
    </svg>
  );
}

const SOCIAL = [
  {
    label: "Instagram",
    href: "https://www.instagram.com/vaibhavsisinty/",
    icon: IconInstagram,
  },
  {
    label: "Threads",
    href: "https://www.threads.com/@vaibhavsisinty",
    icon: IconThreads,
  },
  {
    label: "X",
    href: "https://x.com/VaibhavSisinty",
    icon: IconX,
  },
  {
    label: "LinkedIn",
    href: "https://in.linkedin.com/in/vaibhavsisinty",
    icon: IconLinkedIn,
  },
  {
    label: "YouTube",
    href: "https://www.youtube.com/@vaibhavsisinty",
    icon: IconYouTube,
  },
] as const;

function FooterNavLink({ item }: { item: FooterNavItem }) {
  const className =
    "text-sm text-white/65 transition hover:text-white md:text-[15px]";
  if (item.to) {
    return (
      <Link to={item.to} className={className}>
        {item.label}
      </Link>
    );
  }
  return (
    <a
      href={item.href}
      className={className}
      target="_blank"
      rel="noopener noreferrer"
    >
      {item.label}
    </a>
  );
}

export type HomepageFooterProps = {
  /** Omit the gradient rule above the footer (newsletter post detail). */
  hideTopBorder?: boolean;
  /** Optional extra classes on `<footer>` (e.g. `mt-6` after a section CTA). */
  className?: string;
  /** Called with the trimmed email after client-side validation passes. */
  onEmailContinue?: (email: string) => void;
};

export default function HomepageFooter({
  className = "",
  onEmailContinue,
}: HomepageFooterProps) {
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");

  function handleJoin() {
    const v = email.trim();
    if (!EMAIL_RE.test(v)) {
      setEmailError("Enter a valid email address.");
      return;
    }
    setEmailError("");
    onEmailContinue?.(v);
  }

  const year = new Date().getFullYear();

  return (
    <footer
      id="homepage-cta"
      className={`relative w-full overflow-hidden bg-black font-fira text-white${className ? ` ${className}` : ""}`}
    >
    

      <picture className="pointer-events-none absolute inset-0">
        <source media="(min-width: 768px)" srcSet="/homepage/footd.webp" />
        <img
          src="/homepage/footm.webp"
          alt=""
          className="h-full w-full object-cover"
          loading="lazy"
          decoding="async"
        />
      </picture>

      <div className="relative z-10 mx-auto w-[90%] py-12 md:w-[80%] md:py-16">
        <div className="flex flex-col gap-10 md:flex-row md:items-start md:justify-between md:gap-12 lg:gap-16">
          <div className="order-2 flex flex-col gap-5 md:order-1 md:max-w-xs md:gap-6">
            <Link
              to="/"
              className="inline-flex w-fit items-center gap-2.5"
              aria-label="Staying Ahead home"
            >
              <img
                src="/homepage/salogo.svg"
                alt=""
                className="h-10 w-auto sm:h-11"
                width={140}
                height={40}
                loading="lazy"
                decoding="async"
              />
            </Link>
            <div className="flex flex-wrap items-center gap-3">
              {SOCIAL.map(({ label, href, icon: Icon }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg border border-white/15 bg-white/[0.04] text-white/75 transition hover:border-white/30 hover:text-white"
                >
                  <Icon className="h-[18px] w-[18px]" />
                </a>
              ))}
            </div>
          </div>

          <div className="order-1 md:order-2 md:max-w-xl md:flex-1">
            <h2
              id="homepage-cta-heading"
              className="font-fira-condensed text-[22px] font-semibold leading-tight tracking-tight text-white md:text-[24px] lg:text-[26px]"
            >
              The Next year of AI will not wait
            </h2>
            <p className="mt-3 text-sm font-normal leading-relaxed text-white/60 md:text-[15px]">
              Be the first to find out about the newest programs, workshops,
              and community activities - plus industry news, articles, and
              special reports. All delivered to your inbox!
            </p>

            <div
              className="mt-6 flex flex-col gap-3 md:flex-row md:items-stretch md:gap-4"
              role="group"
              aria-label="Email signup"
            >
              <label className="sr-only" htmlFor="footer-cta-email">
                Email address
              </label>
              <input
                id="footer-cta-email"
                name="email"
                type="email"
                autoComplete="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  if (emailError) setEmailError("");
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleJoin();
                  }
                }}
                aria-invalid={!!emailError}
                aria-describedby={
                  emailError ? "footer-cta-email-error" : undefined
                }
                className={`min-h-12 min-w-0 flex-1 rounded-lg border bg-black/40 px-4 py-3 text-center font-fira text-sm text-white placeholder:text-white/40 backdrop-blur-sm focus:outline-none focus:ring-1 focus:ring-white/30 md:text-left md:text-[0.9375rem] ${
                  emailError
                    ? "border-red-400/50 focus:border-red-400/50"
                    : "border-white/25 focus:border-white/40"
                }`}
              />
              <button
                type="button"
                onClick={handleJoin}
                className="min-h-12 shrink-0 rounded-lg border border-[#FFFFFF4D] bg-white px-6 py-3 font-fira text-sm font-semibold text-black transition-opacity hover:opacity-90 md:text-[0.9375rem]"
              >
                Join Now
              </button>
            </div>
            {emailError ? (
              <p
                id="footer-cta-email-error"
                className="mt-2 text-xs text-red-400"
                role="alert"
              >
                {emailError}
              </p>
            ) : null}
          </div>
        </div>

        <div className="my-10 h-px w-full bg-white/10 md:my-12" />

        <div className="grid grid-cols-2 gap-x-8 gap-y-8 md:gap-x-16">
          <div>
            <h3 className="mb-4 text-base font-semibold text-white">Learn</h3>
            <ul className="flex flex-col gap-3 md:flex-row md:flex-wrap md:gap-x-8 md:gap-y-3">
              {LEARN_LINKS.map((item, idx) => (
                <li key={`${item.label}-${idx}`}>
                  <FooterNavLink item={item} />
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h3 className="mb-4 text-base font-semibold text-white">Connect</h3>
            <ul className="flex flex-col gap-3 md:flex-row md:flex-wrap md:gap-x-8 md:gap-y-3">
              {CONNECT_LINKS.map((item, idx) => (
                <li key={`${item.label}-${idx}`}>
                  <FooterNavLink item={item} />
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="my-10 h-px w-full bg-white/10 md:my-12" />

        <p className="text-sm text-white/50">
          © {year} Sisinty Pvt. Ltd. All rights reserved
        </p>
      </div>
    </footer>
  );
}
